import styled from '@emotion/styled';
import { css } from '@emotion/core';

import COLORS from '$variables/colors';

const styles = css`
  height: 32px;
  width: 32px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid ${COLORS.grey6};
  box-sizing: border-box;
`;

export const Link = styled.a`
  ${styles}

  cursor: pointer;

  svg {
    color: ${({ look }) => look.color};
  }
`;

export const DisabledLink = styled.div`
  ${styles}

  cursor: not-allowed;

  svg {
    color: ${COLORS.grey6};
  }
`;
